import React from 'react';
import {Box, Typography, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import {styled} from '@mui/system';

import {lightenColor} from '../helpers/ColorUtils';
import BookableSelectionButton from './common/BookableSelectionButton'
import CompactTimePickerComponent from "./common/CompactTimePickerComponent";
import {ROUNDING_MINUTES_FOR_SHIFT_TIME} from '../domain/ShiftPlanConstants';

export default function SelectedBookableServices({selectedServiceType, startTime, endTime, onStartTimeChange, onEndTimeChange, onStatusChange, bookableStatus, onRemoveService}) {

    const ServiceTypeBox = styled(Box)(() => ({
        border: '1px solid #ccc',
        borderRadius: '0.5rem',
        padding: '0.5rem',
        paddingTop: '0.7rem',
        marginTop: '0.5rem'
    }));

    const ServiceTypeColor = styled(Box)(() => ({
        width: 20,
        height: 20,
        backgroundColor: lightenColor(selectedServiceType.primaryColor)
    }));

    const ServiceTypeDescription = styled(Typography)(() => ({
        fontSize: 14,
        variant: 'body1'
    }));

    return (
      <ServiceTypeBox>
          <Grid container spacing={3.3} alignItems="center">
              <Grid size={0.7}><ServiceTypeColor/></Grid>
              <Grid size={1.2}>
                  <ServiceTypeDescription>{selectedServiceType.keycode}</ServiceTypeDescription>
              </Grid>
              <Grid size={3}>
                  <CompactTimePickerComponent
                    label={"Start Time"}
                    value={startTime}
                    roundingValue={ROUNDING_MINUTES_FOR_SHIFT_TIME}
                    onChange={onStartTimeChange} />
              </Grid>
              <Grid size={3}>
                  <CompactTimePickerComponent
                    label={"End Time"}
                    value={endTime}
                    roundingValue={ROUNDING_MINUTES_FOR_SHIFT_TIME}
                    onChange={onEndTimeChange} />
              </Grid>
              <Grid size={3}>
                  <BookableSelectionButton onStatusChange={onStatusChange} bookableStatus={bookableStatus}/>
              </Grid>
              <Grid size={1}>
                  <IconButton onClick={onRemoveService}>
                      <CloseIcon/>
                  </IconButton>
              </Grid>
          </Grid>
      </ServiceTypeBox>
    );
}